import superagent from 'superagent'
import Promise from 'bluebird'

const auth0domain = 'art-jump'

export function loadUserMetadata (userid, authkey) {
  const url = `https://${auth0domain}.auth0.com/api/v2/users/${userid}`
  return new Promise((resolve, reject) => {
    superagent.patch(url)
      .set('Accept', 'application/json')
      .set('Authorization', 'bearer ' + authkey)
      .end((err, response) => {
        if (err) {
          reject(err)
        } else {
          resolve(response.result)
        }
      })
  })
}

export function updateUserMetadata (userid, dump, authkey) {
  return new Promise((resolve, reject) => {
    const url = `https://${auth0domain}.auth0.com/api/v2/users/${userid}`
    superagent.patch(url)
      .set('Accept', 'application/json')
      .set('Authorization', 'bearer ' + authkey)
      .send({user_metadata: dump})
      .end((err) => {
        if (err) {
          reject(err)
        } else {
          resolve()
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/shared/userMetadata.js